import { Quotation, Request, User } from 'Types';
import { checkRank } from './checkRank';

interface Props {
  user: User | null;
  request?: Request;
  quotation?: Quotation;
  label?: string;
  type?: string;
}

export const canModifyRequest = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const {
    status: { label },
  } = request;

  if (label !== 'step_1') return false;

  return true;
};

export const canMakeQuotation = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;
  const {
    status: { label },
  } = request;

  if (role === 'CLIENT') return false;

  if (!['step_1', 'step_2', 'step_3', 'step_5'].includes(label)) return false;

  return true;
};

export const canRespond = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;

  if (role === 'CLIENT') return false;

  return true;
};

export const canModifyStatus = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;

  if (role === 'CLIENT') return false;

  return true;
};

export const canSeeOSS = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;

  if (role === 'CLIENT') return false;

  return true;
};

export const canRelaunchRequest = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;
  const {
    status: { label },
  } = request;

  if (role === 'CLIENT') return false;

  if (label !== 'step_2') return false;

  return true;
};

export const canExportTeliway = ({ user, request }: Props): boolean => {
  if (!user || !request) return false;

  const { role } = user;

  const {
    status: { label },
  } = request;

  if (role === 'CLIENT') return false;

  if (label !== 'step_4') return false;

  return true;
};

export const canModifyStatusClient = ({
  user,
  request,
  type,
}: Props): boolean => {
  if (!user || !request) return false;

  const {
    status: { label: requestLabel },
  } = request;

  const { role } = user;

  if (role !== 'CLIENT') return false;

  if (type === 'respond' && !['step_2', 'step_3'].includes(requestLabel))
    return false;

  if (type === 'cancel' && !['step_1'].includes(requestLabel)) return false;

  if (type === 'suspend' && !['step_2', 'step_3'].includes(requestLabel))
    return false;

  return true;
};

export const canRespondQuotation = ({
  user,
  request,
  quotation,
}: Props): boolean => {
  if (!user || !request || !quotation) return false;

  const {
    status: { label: quotationLabel },
  } = quotation;

  const {
    status: { label: requestLabel },
  } = request;

  if (quotationLabel !== 'pending') return false;

  if (!['step_2', 'step_3'].includes(requestLabel)) return false;

  return true;
};

export const canSeeAllStatus = ({ user, label }: Props): boolean => {
  if (!user || !label) return false;

  const { role } = user;

  if (role === 'CLIENT' && !['step_6', 'step_7'].includes(label)) return false;

  return true;
};

export const canCreateUser = ({ user, label }: Props): boolean => {
  if (!user || !label) return false;

  const { role } = user;

  if (role === 'CLIENT') return false;

  return checkRank({ firstRole: role, secondRole: label });
};

export const canExtractStats = ({ user }: Props): boolean => {
  if (!user) return false;

  const { role } = user;

  if (role === 'CLIENT' || role === 'SHIPPER') return false;

  return true;
};

export const canAskRequest = ({ user }: Props): boolean => {
  if (!user) return false;

  const { role } = user;

  if (role !== 'CLIENT') return false;

  return true;
};

export const isAdmin = ({ user }: Props): boolean => {
  if (!user) return false;

  const { role } = user;

  return role === 'ADMIN';
};

export const isClient = ({ user }: Props): boolean => {
  if (!user) return false;

  const { role } = user;

  return role === 'CLIENT';
};